import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IRestBaseListResponse } from '../models';

interface IUserAuditInfo {
  UserId: number;
  UserName: string;
}

@Injectable({ providedIn: 'root' })
export class AuditLogService {
  constructor(private _httpClient: HttpClient) {}

  getUniqueActions(): Observable<IRestBaseListResponse<string>> {
    return this._httpClient.get<IRestBaseListResponse<string>>('Lot/Audit/UniqueActions');
  }

  getUniqueUsers(): Observable<IRestBaseListResponse<IUserAuditInfo>> {
    return this._httpClient.get<IRestBaseListResponse<IUserAuditInfo>>('Lot/Audit/UniqueUsers');
  }
}
